import React from "react";
import iconSearch from "images/ic_search.png";
import styled from "styled-components";
import theme from "styles/theme";

const StyledInput = styled.input`
  height: 56px;
  width: 100%;
  background: ${theme.colors.white};
  box-sizing: border-box;
  padding: 0 ${theme.spacing.unit * 2}px 0 ${theme.spacing.unit * 6}px;
  background: url(${iconSearch}) no-repeat 16px/24px 24px;

  // Border
  border: 2px solid
    ${(props) =>
      props.hasError ? `${theme.colors.red}` : `${theme.colors.gray2}`};
  border-radius: 16px;
  box-shadow: ${(props) =>
    props.hasError ? "0px 2px 4px rgba(0, 0, 0, 0.1)" : "none"};
  outline: none;

  // Placeholders
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${(props) =>
      props.hasError ? `${theme.colors.red}` : `${theme.colors.gray3}`};
  }
  :-ms-input-placeholder {
    color: ${(props) =>
      props.hasError ? `${theme.colors.red}` : `${theme.colors.gray3}`};
  }

  // Text
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) =>
    props.hasError ? `${theme.colors.red}` : `${theme.colors.gray4}`};

  &:focus {
    // Border
    border: 2px solid
      ${(props) =>
        props.hasError ? `${theme.colors.red}` : `${theme.colors.gray4}`};
    box-shadow: "0px 2px 4px rgba(0, 0, 0, 0.1)";

    // Placeholders
    ::placeholder,
    ::-webkit-input-placeholder {
      color: ${(props) =>
        props.hasError ? `${theme.colors.red}` : `${theme.colors.gray4}`};
    }
    :-ms-input-placeholder {
      color: ${(props) =>
        props.hasError ? `${theme.colors.red}` : `${theme.colors.gray4}`};
    }

    // Text
    color: ${(props) =>
      props.hasError ? `${theme.colors.red}` : `${theme.colors.gray4}`};
  }
`;

const SearchInput = (props) => {
  return <StyledInput {...props} aria-label={"Search"} />;
};

export default SearchInput;
